export default __webpack_public_path__ + "static/media/error_sign.0856a28e.svg";